import React from 'react'
import { Col, Input, Button, Form } from 'antd';
import { FaFilePdf, FaFileExcel } from 'react-icons/fa';
export default function FreightPaymentSearch({orderList,setDeliveryOrder,handlePrint,handleExportToExcel}) {
    const [form] = Form.useForm();
    const handleValuesChange = (changedValues, allValues) => {
        const filteredData = orderList.filter(item =>
            item.truck_owner_name.toLowerCase().includes((allValues.truck_owner_name || '').toLowerCase()) &&
            item.pan_no.toLowerCase().includes((allValues.pan_no || '').toLowerCase()) &&
            item.do_no.toLowerCase().includes((allValues.do_no || '').toLowerCase()) &&
            item.vehicle_no.toLowerCase().includes((allValues.vehicle_no || '').toLowerCase())
        );
        setDeliveryOrder(filteredData);
    };
    return (
        <div>
            <Form
                form={form}
                layout="vertical"
                onValuesChange={handleValuesChange}
            >
                <div className=" grid grid-cols-1 sm:grid sm:grid-cols-5 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%]" style={{ marginBottom: '10px' }}>
                    <Col>
                        <label><b>Search By Truck Owner Name</b></label><br />
                        <Form.Item
                            name='truck_owner_name'
                        >
                            <Input
                                placeholder='Search By Truck Owner Name'
                            />
                        </Form.Item>
                    </Col>
                    <Col>
                        <label><b> Search By Do Number</b></label><br />
                        <Form.Item
                            name='do_no'
                        >
                            <Input

                                placeholder='Search By Do Number'
                            />
                        </Form.Item>
                    </Col>
                    <Col>
                        <label><b> Search By PAN No</b></label><br />
                        <Form.Item
                            name='pan_no'
                        >
                            <Input
                                placeholder='Search by PAN No.'

                            />
                        </Form.Item>
                    </Col>
                    <Col>
                    <label><b> Search By Vehicle No</b></label><br />
                        <Form.Item
                            name='vehicle_no'
                        >
                            
                            <Input
                                placeholder='Search by Vehicle No.'
                            />
                        </Form.Item>
                    </Col>
                    <Col>

<Button
  style={{
    bottom:'-10px',
    margin: "10px",
    backgroundColor: 'black',
    color: 'white',
    fontWeight: '600'
  }}
  onClick={handlePrint}
>
  <FaFilePdf/>
</Button>
<Button
  style={{
    bottom:'-10px',
    margin: "10px",
    backgroundColor: 'green',
    color: 'white',
    fontWeight: '600'
  }}
  onClick={handleExportToExcel}
>
  <FaFileExcel/>
</Button>
</Col>

                </div>
            </Form>
        </div>
    )
}
